import * as Constants from "../utils/constants";
import axios from "axios";
const token = localStorage.getItem("token");

if (token) {
  Constants.setAuthToken(token);
}

export const reportBug = async (bugsDetailes) => {
  try {
    const response = await axios.post(
      Constants.reportBug,
      bugsDetailes,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    console.error("Error reporting bug:", error);
    return {
      status: "error",
      message:
        error.response?.data?.message ||
        "An error occurred while reporting the bug.",
    };
  }
};
